<template lang="pug">
.order-address-map(v-if="lat && lng")
  iframe.order-address-map-iframe(
    :src="embedUrl"
    frameborder="0"
    allowfullscreen
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
  )
  .order-address-map-coords {{ lat }}, {{ lng }}
</template>

<script>
export default {
  name: 'OrderAddressMap',

  props: {
    lat: {
      type: Number,
      default: null
    },
    lng: {
      type: Number,
      default: null
    }
  },

  computed: {
    embedUrl () {
      return `https://maps.google.com/maps?q=${this.lat},${this.lng}&z=17&output=embed`
    }
  }
}
</script>

<style scoped>
.order-address-map {
  margin-top: 0.75rem;
}
.order-address-map-iframe {
  width: 100%;
  height: 280px;
  border-radius: 6px;
  border: 1px solid #ddd;
}
.order-address-map-coords {
  font-size: 0.85rem;
  color: #888;
  margin-top: 0.25rem;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/order/OrderAddressMap.vue